// LocationData.js
export const LocationData = {
  countries: [
    { name: "India", code: "IN" },
    { name: "United States", code: "US" },
    { name: "United Kingdom", code: "UK" },
    { name: "Europe", code: "EU" },
  ],
  states: {
    IN: [
      { name: "Uttar Pradesh", code: "UP" },
      { name: "Maharashtra", code: "MH" },
      { name: "Karnataka", code: "KA" },
      { name: "Rajasthan", code: "RJ" },
      { name: "Tamil Nadu", code: "TN" },
    ],
    US: [
      { name: "California", code: "CA" },
      { name: "Texas", code: "TX" },
      { name: "New York", code: "NY" },
      { name: "Florida", code: "FL" },
      { name: "Illinois", code: "IL" },
    ],
    UK: [
      { name: "England", code: "ENG" },
      { name: "Scotland", code: "SCO" },
      { name: "Wales", code: "WAL" },
      { name: "Northern Ireland", code: "NI" },
    ],
    EU: [
      { name: "France", code: "FR" },
      { name: "Germany", code: "DE" },
      { name: "Italy", code: "IT" },
      { name: "Spain", code: "ES" },
      { name: "Netherlands", code: "NL" },
    ],
  },
  cities: {
    UP: [
      { name: "Lucknow", code: "LKO" },
      { name: "Kanpur", code: "KNP" },
      { name: "Varanasi", code: "VNS" },
      { name: "Agra", code: "AGR" },
    ],
    MH: [
      { name: "Mumbai", code: "BOM" },
      { name: "Pune", code: "PUN" },
      { name: "Nagpur", code: "NAG" },
      { name: "Nashik", code: "NSK" },
    ],
    KA: [
      { name: "Bengaluru", code: "BLR" },
      { name: "Mysuru", code: "MYS" },
      { name: "Hubli", code: "HBL" },
      { name: "Mangalore", code: "MNG" },
    ],
    RJ: [
      { name: "Jaipur", code: "JAI" },
      { name: "Jodhpur", code: "JOD" },
      { name: "Udaipur", code: "UDA" },
      { name: "Ajmer", code: "AJM" },
    ],
    CA: [
      { name: "Los Angeles", code: "LA" },
      { name: "San Francisco", code: "SF" },
      { name: "San Diego", code: "SD" },
      { name: "Sacramento", code: "SAC" },
    ],
    TX: [
      { name: "Houston", code: "HOU" },
      { name: "Dallas", code: "DAL" },
      { name: "Austin", code: "AUS" },
      { name: "San Antonio", code: "SA" },
    ],
    ENG: [
      { name: "London", code: "LDN" },
      { name: "Manchester", code: "MAN" },
      { name: "Birmingham", code: "BIR" },
      { name: "Liverpool", code: "LIV" },
    ],
    SCO: [
      { name: "Edinburgh", code: "EDI" },
      { name: "Glasgow", code: "GLA" },
      { name: "Aberdeen", code: "ABD" },
      { name: "Dundee", code: "DUN" },
    ],
    FR: [
      { name: "Paris", code: "PAR" },
      { name: "Lyon", code: "LYO" },
      { name: "Marseille", code: "MAR" },
      { name: "Nice", code: "NCE" },
    ],
    DE: [
      { name: "Berlin", code: "BER" },
      { name: "Munich", code: "MUC" },
      { name: "Frankfurt", code: "FRA" },
      { name: "Hamburg", code: "HAM" },
    ],
  },
};
